import { Link as RouterLink, type LinkProps } from 'react-router-dom';

const tableStyledLinkClass =
  'text-left text-base font-normal not-italic leading-6 text-[var(--color-text)] underline hover:text-[var(--color-accent)]';

export const TableStyledLink = ({ className, ...props }: LinkProps) => (
  <RouterLink className={[tableStyledLinkClass, className].filter(Boolean).join(' ')} {...props} />
);
